/**
 * Статья блога (`single.php`): оглавление, липкий сайдбар, слайдер
 * «Новые статьи».
 *
 * Перенесено из инлайн-блока `<script>` шаблона, 110 строк
 * (Этап 6 §0 группа 6, 👤 указание владельца «все инлайн скрипты
 * переносить в файлы»).
 *
 * 🔴 Слайдер переписан со Splide на Swiper — 👤 «splide нужно будет
 * удалить и заменить на swiper если нужно». Splide был ПОСЛЕДНИМ
 * потребителем `assets/js/splide.min.js` (29,8 КБ) и
 * `assets/css/splide.min.css` (5,0 КБ): второй его блок,
 * `students-results`, оказался мёртв и удалён целиком. Swiper в проекте
 * уже есть через npm и приходит динамическим `import`-ом.
 *
 * ⚠️ Опции Splide → Swiper переведены не буква в букву: у библиотек
 * РАЗНАЯ логика брейкпоинтов. У Splide `breakpoints: { 991: ... }` —
 * это «при ширине ДО 991 включительно», max-width. У Swiper —
 * min-width. Поэтому базой стал мобильный вариант (1 слайд), а три
 * слайда включаются от 992px. Пара (≤991 → 1) и (≥992 → 3) совпадает
 * с исходной: замер на 992px дал 3 карточки и до, и после.
 */

/**
 * Опции слайдера «Новые статьи».
 *
 * Соответствие исходным опциям Splide:
 *   type: 'loop'            → loop: true
 *   perPage: 3 / 1          → slidesPerView (см. breakpoints)
 *   perMove: 1              → slidesPerGroup: 1
 *   gap: '20px'             → spaceBetween: 20
 *   speed: 600              → speed: 600
 *   drag: true              → allowTouchMove (включено по умолчанию)
 *   pagination: false       → модуль Pagination не подключён
 *   padding: {left,right:0} → эквивалента не нужно, отступов не было
 */
const SLIDER = {
    loop: true,
    speed: 600,
    spaceBetween: 20,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
        992: {
            slidesPerView: 3,
        },
    },
    // 🔴 Свои классы, а НЕ `.swiper-button-next/prev`. Иначе к кнопкам
    // применился бы CSS модуля Navigation (`swiper/css/navigation`):
    // он задаёт свои размеры через `--swiper-navigation-size` и псевдо-
    // элемент со шрифтовой иконкой, и кнопки разъехались бы с эталоном
    navigation: {
        nextEl: '.popular-posts__arrow--next',
        prevEl: '.popular-posts__arrow--prev',
    },
};

/**
 * Кнопка «Раскрыть содержание»: сворачивает оглавление до 2 пунктов.
 *
 * ⚠️ Ограничено статьёй блога сознательно. Список
 * `.table-of-contents__list` есть и на странице автора
 * (`single-authors.php`, например `/authors/zajczeva-aleksandra/`),
 * но переключатель там НЕ подключался — инлайн жил только в `single.php`.
 * Без проверки на `main.blog-detail` модуль из общего бандла добавил бы
 * кнопку и свернул оглавление на страницах авторов, то есть изменил бы
 * вид страниц, которых правка не касается.
 *
 * Сворачивание держится на классе `collapsed`: правило
 * `.table-of-contents__list.collapsed li:nth-child(n+3) { display: none }`
 * лежит в `assets/css/blog-detail.min.css`.
 */
function initTableOfContentsToggle() {
    const tocList = document.querySelector('.table-of-contents__list');
    if (!tocList) return;

    const tocItems = tocList.querySelectorAll('li');
    // Если пунктов 2 или меньше, сворачивать нечего
    if (tocItems.length <= 2) return;

    const CHEVRON = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502" stroke="#212121" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const CHEVRON_UP = CHEVRON.replace('xmlns="http://www.w3.org/2000/svg"', 'xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);"');

    const toggleBtn = document.createElement('button');
    toggleBtn.className = 'table-of-contents__toggle';
    toggleBtn.type = 'button';
    toggleBtn.innerHTML = `Раскрыть содержание ${CHEVRON}`;

    tocList.classList.add('collapsed');
    tocList.parentNode.insertBefore(toggleBtn, tocList.nextSibling);

    toggleBtn.addEventListener('click', () => {
        tocList.classList.toggle('collapsed');

        const collapsed = tocList.classList.contains('collapsed');
        toggleBtn.innerHTML = collapsed
            ? `Раскрыть содержание ${CHEVRON}`
            : `Скрыть содержание ${CHEVRON_UP}`;
    });
}

/**
 * Липкий сайдбар статьи.
 *
 * Перенесено 1:1, включая два порога-константы: прокрутка 1200px
 * и высота окна 800px.
 *
 * ⚠️ Логика неочевидна и переносится как есть: при высоте окна
 * ОТ 800px липнет весь блок `.aside-fixed`, а ниже 800px — только
 * баннер `.widget-promo`, потому что целиком он бы не поместился.
 * Ветки взаимно гасят классы друг друга, поэтому при ресайзе
 * состояние не залипает.
 *
 * ⚠️ Добавлены проверки на наличие `sidebar` и `articlesWidget`,
 * которых в инлайне не было: там `sidebar.offsetHeight` и
 * `articlesWidget.classList` читались без них. На статье блога все три
 * элемента есть всегда (замерено), так что поведение не меняется —
 * но исключение в обработчике `scroll` убивало бы его молча.
 */
function initFixedSidebarArticles() {
    const articlesWidget = document.querySelector('.aside-fixed');
    const promoWidget = document.querySelector('.widget-promo');
    const sidebar = document.querySelector('.blog-detail__aside');

    if (!sidebar || (!articlesWidget && !promoWidget)) return;

    function handleScroll() {
        const isSmallHeight = window.innerHeight < 800;

        if (articlesWidget && !isSmallHeight) {
            // Высота окна от 800px — фиксируется весь блок
            promoWidget?.classList.remove('fixed', 'stuck');

            articlesWidget.classList.toggle('fixed', window.scrollY > 1200);
            articlesWidget.classList.toggle(
                'stuck',
                window.scrollY > sidebar.offsetHeight - articlesWidget.offsetHeight,
            );
        } else if (promoWidget && isSmallHeight) {
            // Высота окна меньше 800px — фиксируется только баннер
            articlesWidget?.classList.remove('fixed', 'stuck');

            promoWidget.classList.toggle('fixed', window.scrollY > 1200);
            promoWidget.classList.toggle(
                'stuck',
                window.scrollY > sidebar.offsetHeight - promoWidget.offsetHeight,
            );
        }
    }

    document.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
}

/** Слайдер «Новые статьи» в подвале статьи. */
async function initPopularSlider() {
    // 🔴 Инициализируется ВНУТРЕННИЙ `.swiper`, а не сам
    // `.popular-posts__slider`. Разделение нужно из-за `overflow`:
    // у Swiper он `hidden` прямо на `.swiper`, а стрелки вылетают
    // за край на 10px и были бы срезаны. Кнопки лежат снаружи,
    // в `.popular-posts__slider` — он и служит точкой отсчёта
    // для `position: absolute`. У Splide роль обрезки играл
    // внутренний `.splide__track`, схема повторена
    const slider = document.querySelector('.popular-posts__slider .swiper');
    if (!slider) return;

    const [{ default: Swiper }, { Navigation }] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
    ]);

    // Модуль перечисляется явно: без него слайдер соберётся и будет
    // листаться свайпом, но кнопки останутся мёртвыми и об ошибке
    // Swiper не сообщит
    new Swiper(slider, { ...SLIDER, modules: [Navigation] });
}

export default async function BlogDetail() {
    // Якорь — `main.blog-detail`, он есть только в `single.php`.
    // Проверка защищает и от загрузки Swiper на чужих страницах:
    // модуль лежит в общем бандле
    if (!document.querySelector('main.blog-detail')) return;

    // Порядок как в инлайне: сайдбар, оглавление, затем слайдер.
    // Первые две функции синхронны и успевают до `await` внутри
    // `initPopularSlider`, то есть до запроса чанка Swiper
    initFixedSidebarArticles();
    initTableOfContentsToggle();

    await initPopularSlider();
}
